export const routerList = [
  {
    label: 'Stake',
    path: '/dashboard?type=stake',
    query: {
      type: 'stake',
    },
  },
  {
    label: 'Unstake',
    path: '/dashboard?type=unstake',
    query: {
      type: 'unstake',
    },
  },
  {
    label: 'Bridge',
    path: '/bridge',
  },
  {
    label: 'Stats',
    path: '/stats',
  },
]
